import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/document.svg'


const _hoisted_1 = ["value"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-fileupload-file-actions" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "p-fileupload-file-name" }
const _hoisted_7 = { class: "p-fileupload-file-size" }
const _hoisted_8 = { class: "error-msg" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      type: "hidden",
      value: $props.modelValue
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass({ error: $props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name] && $props.v$.value[$props.propname ?? $props.name].$errors.length })
    }, [
      _createVNode(_component_FileUpload, {
        ref: "FileUploadCtrl",
        name: $props.name,
        accept: $props.accept,
        multiple: $props.multiple,
        auto: $props.auto,
        fileLimit: $props.fileLimit,
        showCancelButton: false,
        maxFileSize: $props.maxFileSize,
        url: "",
        onSelect: $setup.onSelectFile,
        chooseIcon: $props.chooseIcon,
        chooseLabel: $props.chooseLabel,
        showUploadButton: $props.showUploadButton,
        disabled: $props.Isdisabled
      }, _createSlots({ _: 2 /* DYNAMIC */ }, [
        (!$setup.Props.modelValue)
          ? {
              name: "empty",
              fn: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("p", null, "No files uploaded.", -1 /* CACHED */))
              ]),
              key: "0"
            }
          : undefined,
        ($setup.UploadedFiles.length > 0)
          ? {
              name: "content",
              fn: _withCtx(() => [
                ($setup.UploadedFiles.filter(x => !('IsDeleted' in x) || !x.IsDeleted).length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("p", null, "No files uploaded.", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.UploadedFiles.filter(x => !('IsDeleted' in x) || !x.IsDeleted), (obj, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "p-fileupload-file",
                    key: obj.name
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.onRemoveFile(index, obj.Id)),
                        class: "p-button-outlined p-button-danger p-button-rounded"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]),
                    _createElementVNode("img", {
                      role: "presentation",
                      onClick: ($event: any) => ($setup.downloadFile(obj)),
                      src: _imports_0,
                      class: "p-fileupload-file-thumbnail"
                    }, null, 8 /* PROPS */, _hoisted_4),
                    _createElementVNode("div", {
                      class: "p-fileupload-file-details",
                      onClick: ($event: any) => ($setup.downloadFile(obj))
                    }, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(obj.name ?? obj.Name), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(obj.size), 1 /* TEXT */),
                      _createVNode(_component_Badge, {
                        value: obj.status ?? 'Pending',
                        severity: obj.status == 'Completed' ? 'success' : 'warning',
                        class: "p-fileupload-file-badge"
                      }, null, 8 /* PROPS */, ["value", "severity"])
                    ], 8 /* PROPS */, _hoisted_5)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              key: "1"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["name", "accept", "multiple", "auto", "fileLimit", "maxFileSize", "chooseIcon", "chooseLabel", "showUploadButton", "disabled"])
    ], 2 /* CLASS */),
    (($setup.ErrorFiles || []).length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.ErrorFiles, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "fileupload-input-errors",
            key: error
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(error), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($props.v$ && $props.v$.value && $props.v$.value[$props.propname ?? $props.name])
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.v$.value[$props.propname ?? $props.name].$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}